import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {

	Box,

	TextField,
	Typography,
} from "@mui/material";

import Localisation3 from "../Common/Localisation3";
import MuiAlert from "@mui/lab/Alert";
import LoadingButton from "@mui/lab/LoadingButton";



export default function SellerDetailsStep2({ upperState, setUpperState, setBackDrop, setSnackState }) {
	const [complete, setComplete] = useState(false);
	const [loadingState, setLoadingState] = useState(false);

	const [state, setState] = useState(upperState);
	const handleChange = (event) => {
		console.log("handlechange");
		setState({ ...state, [event.target.name]: event.target.value });
	};
	const handleChangeLoc = (loc) => {
		//console.log(loc.center[0], loc.center[1]);
		setState({ ...state, loc: loc, has_loc: true, addr_line1: loc.adr1 });
	};

	const skip = (event) => {
		setUpperState({ ...upperState, step: 2 });
	};
	function ValidatePwd(num) {
		if (num === undefined) return false;
		if (num.length == 10 && (num.substring(0, 2) == "06" || num.substring(0, 2) == "07")) {
			return true;
		}
		if (num.length == 12 && (num.substring(0, 4) == "+336" || num.substring(0, 4) == "+337")) {
			return true;
		}
		//console.log("pwd", num, false);
		return false;
	}
	useEffect(() => {
		console.log("useEffect", state);
		if (state.phone1 !== "" && state.addr_line1 !== "" && state.addr_zip_code !== "" && state.addr_city !== "" && ValidatePwd(state.phone1)) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [state]);
	const manageSubmit = () => {

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify(state),
		};

		fetch("/api/8bfe3140ced3431eb3758487f7eefe06", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						location.replace("/devenir-vendeur/2");
						break;

					case "err":
						setBackDrop(false);
						setSnackState({
							open: true,
							body: res.reason,
							severity: "error",
						});
						break;
					default:
						break;
				}
			});
	};
	console.log(state);
	return (
		<div style="padding-right: 10px; padding-left: 10px;">
			<div>
				<Typography variant="h5">Numéro de téléphone</Typography>
			</div>
			<div>
				<Box display="flex" alignItems="center" justifyContent="space-between" p={1} m={1} style="padding: 0px; margin: 0px;">
					<Box p={1} style="padding: 0px; margin: 0px;">
						<TextField
							id="phone1"
							name="phone1"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Téléphone principal *"

							value={state.phone1}
							onChange={handleChange}
							margin="dense"
							size="small"
						/>
					</Box>
				</Box>
			</div>
			<div>
				<Typography variant="caption">Le numéro de téléphone peut être au format français "06XXXXXXXX"</Typography>
				<Typography variant="caption">ou international "+33XXXXXXXX"</Typography>
			</div>


			<div style="margin-top: 20px;">
				<Typography variant="h6">Adresse</Typography>
			</div>
			<Localisation3 upperState={state} mode="AMB" upperSendLoc={handleChangeLoc} />

			<Box display="flex" alignItems="center" justifyContent="flex-end" p={1} m={1} style="padding: 0px; margin: 0px;">
				<Box p={1} style="padding: 0px; margin: 0px;">
					<LoadingButton loading={loadingState} onClick={manageSubmit} variant="contained" color="primary" disabled={!complete}>
						Suivant
					</LoadingButton>
				</Box>
			</Box>
		</div>
	);
}
